import type { TagId, TagConfig } from 'src/types/types';

import styles from './styles.module.scss';

type TagProps = {
  tag: TagId;
  config: Record<TagId, TagConfig>;
};

export const TagItem = ({ tag, config }: TagProps) => {
  const c = config[tag];

  return (
    <li className={styles.tag} style={{ background: c.bg, color: c.color }}>
      {c.label}
    </li>
  );
};
